/**
 * Slick Slider
 *
 * @example
 * slider('.js-slider', {dots: false});
 *
 * @author Fedor Kudinov <brothersrabbits@mail.ru>
 *
 * @param {string} element - Element
 * @param {Object} [options={}] - Options
 *
 * @returns {void}
 */
const slider = (element, options = {}) => {
    const defaults = {
        slidesToShow: 1,
        adaptiveHeight: true,
        autoplay: false,
        autoplaySpeed: 2000,
        dots: false,
    };

    const settings = $.extend({}, defaults, options);

    $(element).slick(settings);
};

export default slider;
